define('siteObj', function() {
  'use strict';
  return window.siteObj;
});
